import React, { useState, useEffect } from "react";
import DriveEtaIcon from "@mui/icons-material/DriveEta";
import TuneIcon from "@mui/icons-material/Tune";
import BoltIcon from "@mui/icons-material/Bolt";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

const ResponsiveFeaturesBar = () => {
  const theme = {
    primary: "#c84653",
  };

  const features = [
    {
      icon: DriveEtaIcon,
      text: "Chauffeur inclus",
    },
    {
      icon: TuneIcon,
      text: "Flexible & Sur-mesure",
    },
    {
      icon: BoltIcon,
      text: "Réponse rapide",
    },
    {
      icon: EventAvailableIcon,
      text: "Événements privés & pros",
    },
  ];

  const [currentFeature, setCurrentFeature] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (!isMobile) return;

    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentFeature((prev) => (prev + 1) % features.length);
        setIsAnimating(false);
      }, 150);
    }, 1500);

    return () => clearInterval(interval);
  }, [isMobile]);

  const containerStyle = {
    maxWidth: 1200,
    margin: "48px auto 0 auto",
    background: "#fff",
    borderRadius: 18,
    boxShadow: "0 4px 16px rgba(200,70,83,0.07)",
    padding: "18px 0",
    fontSize: 18,
    fontWeight: 500,
    color: theme.primary,
    letterSpacing: 1,
  };

  const desktopStyle = {
    ...containerStyle,
    display: "flex",
    justifyContent: "center",
    gap: 48,
  };

  const mobileStyle = {
    ...containerStyle,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 64,
    position: "relative",
    overflow: "hidden",
    marginLeft: 24,
    marginRight: 24,
  };

  const featureStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    transform: isAnimating ? "translateY(-10px)" : "translateY(0)",
    opacity: isAnimating ? 0 : 1,
  };

  const iconStyle = {
    color: theme.primary,
    fontSize: 28,
    opacity: 0.8,
    width: 28,
    height: 28,
  };

  const CurrentIcon = features[currentFeature].icon;

  if (isMobile) {
    return (
      <div style={mobileStyle}>
        <div style={featureStyle}>
          <CurrentIcon style={iconStyle} />
          {features[currentFeature].text}
        </div>
      </div>
    );
  }

  return (
    <div style={desktopStyle}>
      {features.map((feature, index) => {
        const Icon = feature.icon;
        return (
          <div
            key={index}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <Icon style={iconStyle} />
            {feature.text}
          </div>
        );
      })}
    </div>
  );
};

export default ResponsiveFeaturesBar;
